var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%"},attrs:{"id":"cui-cancelled"}},[_c('div',{staticStyle:{"text-align":"center","font-size":"10vw","color":"red"}},[_c('i',{staticClass:"el-icon-circle-close"}),_c('br'),_c('span',{staticStyle:{"font-size":"2vw"}},[_vm._v("Cancelled")])])])
}]

export { render, staticRenderFns }